import { makeStyles } from 'tss-react/mui';

const useStylesEventExtra = makeStyles()((theme) => {
    return {
        optionsRow: {
            display: 'flex',
            alignItems: 'center',
        },
        buttonStyle: {
            paddingRight: '4px',
            borderRadius: '8px',
            fontSize: '0.7rem',
            width: '100%',
            height: '32px',
            textTransform: 'none',
            fontWeight: '500',
            marginTop: theme.spacing(1),
            // marginRight: theme.spacing(1),
            marginBottom: theme.spacing(1),
            [theme.breakpoints.up('xl')]: {
                height: '42px',
                borderRadius: theme.custom.borderRadiusLarge,
                fontSize: '14px',
                fontWeight: '600',
            },
            padding: '4px 10px',
            boxShadow: 'none',
            backgroundColor: '#e0e0e0',
        },
        saveButton: {
            color: '#FFF',
            fontWeight: '600',
            [theme.breakpoints.up('xl')]: {
                fontWeight: '600',
            },
            backgroundColor: `${theme.palette.primary.main} !important`,
            '&:disabled': {
                color: 'white',
                backgroundColor: '#e0e0e0 !important',
            },
        },
        variantOption: {
            width: 'fit-content',
            wordBreak: 'break-word',
        },
        variantContent: {
            background: ' #FFFFFF 0% 0% no-repeat padding-box',
            border: '1px solid #00000021',
            borderRadius: '10px',
        },
        editVariant: {
            borderRadius: '10px 10px 0px 0px',
            background: 'red',
            color: '#FFFFFF',
        },
        positionEnd: {
            display: 'flex',
            justifyContent: 'flex-end',
            width: '100%',
        },

        extraOption: {
            width: 'fit-content',
            wordBreak: 'break-word',
        },

        extraRowSpan: {
            fontSize: '0.75rem',
            fontFamily: 'Montserrat',
            lineHeight: '1.5',
        },

        extraContent: {
            background: ' #FFFFFF 0% 0% no-repeat padding-box',
            border: '1px solid #00000021',
            borderRadius: '10px',
            padding: theme.spacing(0, 0.5),
        },
        p10px: {
            padding: '10px',
        },
        pb10px: {
            paddingBottom: '10px',
            [theme.breakpoints.up('xl')]: {
                paddingBottom: '12px',
            },
        },
        mlr10px: {
            margin: '0px 10px 0px',
        },
        mb20px: {
            marginBottom: '20px',
        },
        pt10px: {
            paddingTop: '10px',
        },
        varOptText: {
            fontWeight: 'bold',
        },
        editExtra: {
            borderRadius: '10px 10px 0px 0px',
            background: 'red',
            color: '#FFFFFF',
        },
        actionsIcons: {
            '& .MuiSvgIcon-root': {
                fontSize: '18px !important',
                color: 'black',
            },
        },
        contentWidth: {
            width: '50%',
        },
        toolbar: {
            display: 'flex',
            alignItems: 'center',
            marginTop: '15px',
            paddingLeft: '16px',
            [theme.breakpoints.up('xl')]: {
                marginTop: '18px',
                paddingLeft: '20px',
            },
        },
        iconButton: {
            color: 'black',
            padding: '0',
            width: '22px',
            height: '22px',
            marginRight: '25px',
            '& svg': {
                fontSize: '22px',
            },
            [theme.breakpoints.up('xl')]: {
                width: '28px',
                height: '28px',
                marginRight: '32px',
                '& svg': {
                    fontSize: '28px',
                },
            },
        },
        iconButtonSelected: {
            color: theme.palette.primary.main,
        },

        formInsideExtraForm: {
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            padding: '16px',
        },
        scroll: {
            /* Hide scrollbar for IE, Edge and Firefox */
            scrollbarWidth: 'none',
            /* Hide scrollbar for Chrome, Safari and Opera */
            '&::-webkit-scrollbar': {
                display: 'none',
            },
        },
        sunEditor: {
            zIndex: 0,
        },
    };
});

export default useStylesEventExtra;
